export default {
	common: {
        subTitle: "常見問題中心",
		title: "常見問題",
		allReady: "全部已加載",
		loadFail: "加載失敗",
		searchResult: "搜索結果",
		questionDetail: "問題詳情",
		noData: "暫無信息",
		all: "全部",
		refresh: "點擊重新加載",
		noInfo: "無匹配數據",
		search: "搜索",
		placeholder: "請輸入問題關鍵字",
		isSolve:"以上內容是否解决您的問題？",
		resolved:"已解决",
	  	unresolved:"未解决",
		share: "港股美股，就選壹隆",
		onlineTip: "熱線忙，優先選擇我的客服",
		service: "電話客服",
		cancel: "取消",
		customerService: "聯繫客服",
		priorService: "熱線忙，優先選擇在線客服",
		accessService: "接入在線客服",
		allResults: '全部相關結果'
	},
	router: {
		title: "常見問題",
		home: "",
		about: "",
	}
};